import { connect } from 'react-redux';
import SmsTemplateDeleteModal, { DispatchPropsType, MapStatePropsType } from '../organisms/templates/deleteModal';
import { IStateType } from '../../../../store/models/root.interface';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { requestObjects } from '../../../../store/Objects';
import { Instances } from '../../../../constants';
import { closeModal, getIsOpen, getParams } from '../../../../store/modals';
import { deleteTemplate, deleteTemplateIds } from '../../../../store/actions/SMSTemplates.action';

const mapStateToProps = (state: IStateType) => ({
    modalVisibility: getIsOpen(state),
    Params: getParams(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    onDeleteTemplates: (reqData: string[], title: string, cb: (res: any, success: boolean) => void) => dispatch(deleteTemplate({ activity_log_action: "Deleted",activity_log_object: "SMS TEMPLATE", activity_log_object_value: title, data: { template_ids: reqData } }, (response: any, flag: boolean) => cb(response, flag))),
    onLoadTemplates: () => dispatch((requestObjects(Instances.smsTemplate))),
    onCloseModal: () => dispatch(closeModal()),
    onDeleteTemplateIds: () => dispatch(deleteTemplateIds([], ""))
});

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(SmsTemplateDeleteModal));